module.exports = __webpack_public_path__ + "static/kanban-eed1b5caa065f481ccc19104c46d4de7.png";